import script from "./LicenseExpire.vue?vue&type=script&lang=ts&setup=true"
export * from "./LicenseExpire.vue?vue&type=script&lang=ts&setup=true"

import "./LicenseExpire.vue?vue&type=style&index=0&id=118469b6&lang=scss"

const __exports__ = script;

export default __exports__